import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Media from 'react-media';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { TextValidator, ValidatorForm } from 'react-material-ui-form-validator';

import Constants from "../utils/Constants";
import PhoneValidator from './PhoneValidator';
import StandardFormLayout from './StandardFormLayout';
import DialogSlideTransition from "./DialogSlideTransition";
import Fido from '../utils/Fido';

import {
	Grid,
	Button,
	Checkbox,
	Dialog,
	DialogContent,
	DialogContentText,
	withMobileDialog,
	Typography,
	IconButton,
	withStyles,
	withTheme,
	FormControlLabel
} from '@material-ui/core';

const styles = theme => ({
	root: {
		[theme.breakpoints.up('sm')]: {
			paddingTop: theme.spacing(4)
		}
	},

	recipientGrid: {
		marginTop: theme.spacing(1),
		paddingLeft: theme.spacing(1.5),
		background: theme.palette.grey[200]
	},

	formContentText: {
		[theme.breakpoints.down('sm')]: {
			marginTop: theme.spacing(9)
		}
	},

	dialogPaper: {
		[theme.breakpoints.up('md')]: {
			maxWidth: 600
		}
	},

	fieldCol: {
		flex: 1,
		paddingLeft: theme.spacing(1.5)
	},

	h1Override: {
		fontWeight: 500
	},

	cancelBtnItem: {
		paddingRight: theme.spacing(1)
	}
});

class ShareEscalationForm extends Component {
	constructor(props) {
		super(props);

		this.state = {
			anchorEl: null,
			recipients: [],
			message: '',
			isFormValid: false,
			selectedRecipients: []
		};

		this.keylength = 0;

		this.menuClick = this.menuClick.bind(this);
		this.menuClose = this.menuClose.bind(this);
		this.handleFormClose = this.handleFormClose.bind(this);
		this.handleFormSubmit = this.handleFormSubmit.bind(this);
		this.dialogEntered = this.dialogEntered.bind(this);
	}

	dialogEntered(prevProps, prevState) {
		let poodle = new Fido();
		poodle.fetch(`/users`, {
			method: "GET",			
		})
		.then(data => {
			console.log('Acct Users', data.users);            
            this.setState({recipients: data.users});
		})
		// .catch(error => props.showSnackbar(error.message));
	}

	menuClick(event) {
		this.setState({ anchorEl: event.target });
	}

	menuClose(event) {
		this.setState({ anchorEl: null });
	}

	
	handleFormSubmit(event) {
		let form = event.target;
		let payload = {};
		this.state.selectedRecipients.forEach((email, index) => {
			const key = `email-${index + 1}`;
			payload[key] = email;
		});

		this.props.handleSubmit(this.props.activityId, payload);
	}

	handleFormClose(event) {
		// Reset form state
		
		this.setState({
			anchorEl: null,
			message: '',
			isFormValid: false
		});

		this.props.handleClose(event);
	}

	selectUser = (ev, email) => {		
		if(ev.target.checked) {
			this.state.selectedRecipients.push(email);
		} else {
			const index = this.state.selectedRecipients.findIndex(x => x === email);
			this.state.selectedRecipients.splice(index, 1);
		}		
	};

	selectAllUsers = (ev) => {
		if(ev.target.checked) {					
			this.state.recipients.forEach(x => {
				this.state.selectedRecipients.push(x.email);
				this.setState(this.state);
			})
		} else {
			this.state.recipients.forEach(x => {
				this.state.selectedRecipients.splice(0, this.state.selectedRecipients.length);
				this.setState(this.state);
			})
		}
	}

	render() {
		let {open, classes, fullScreen, theme} = this.props;
		let {recipients} = this.state;

		return (
			<Dialog
				open={open}
				onEntered={this.dialogEntered}
				onClose={this.handleFormClose}
				fullScreen={fullScreen}
				maxWidth={false}
				classes={{paper: classes.dialogPaper}}
				aria-labelledby="form-dialog-title"
				TransitionComponent={DialogSlideTransition} >				
				<DialogContent>
					<DialogContentText className={classes.formContentText}>
						A direct link to this activity will be sent to each recipient. The link expires 30 days after the original post was published.
					</DialogContentText>
					<ValidatorForm
						//ref={(vForm) => {this.vForm = vForm;}}
						debounceTime={500}
						onSubmit={this.handleFormSubmit}
						onError={errors => console.error(errors)}>
						<Grid className={classes.recipientGrid} container justify="space-between" alignItems="center" spacing={1}>
							<Grid item>
								<Typography variant="h6">Recipients</Typography>
							</Grid>							
						</Grid>						
						<StandardFormLayout>
						<FormControlLabel
							control={
							<Checkbox
								color="primary"
								onChange={(ev) => this.selectAllUsers(ev, recipients)}
								className={classes.checkbox}								
								inputProps={{
									'aria-label': "Select All"
								}}/>
							}
							label="All Users"
						  />
							{/*validatorListener={this.checkValidation}*/}																
							{recipients.map((recipient, idx) =>
								(
									<Grid container justify="space-between" alignItems="flex-end" key={recipient.key} name={recipient.key}>
										<Grid item className={classes.fieldCol}>
										<Checkbox
										checked={this.state.selectedRecipients.includes(recipient.email)}
										className={classes.checkbox}
										onChange={(ev) => this.selectUser(ev, recipient.email)}
										color="primary"/>
										{recipient.first_name + ' ' + recipient.last_name}
										</Grid>										
									</Grid>
								)
							)}							
						</StandardFormLayout>
						<Grid container justify="flex-end">
							<Media
								query={{minWidth: theme.breakpoints.values.md}}
								render={() =>
									<Grid item className={classes.cancelBtnItem}>
										<Button onClick={this.handleFormClose}>Cancel</Button>
									</Grid>
								}>
							</Media>
							<Grid item>
								<Button type="submit" variant="contained" color="primary">
									Share Activity
								</Button>
							</Grid>
						</Grid>
					</ValidatorForm>
				</DialogContent>
			</Dialog>
		);
	}
}

ShareEscalationForm.propTypes = {
	classes: PropTypes.object,
	handleSubmit: PropTypes.func,
	handleClose: PropTypes.func,
	activityId: PropTypes.number,
	open: PropTypes.bool,
	fullScreen: PropTypes.bool,
	theme: PropTypes.object.isRequired,
	defaultRecipient: PropTypes.string
};

export default withStyles(styles)(withMobileDialog()(withTheme(ShareEscalationForm)));
